module.exports = __webpack_public_path__ + "img/YouPlusZH-10.b6adb329.jpg";